export default __webpack_public_path__ + "static/media/banner-desktop@2x.79964670.png";